import axios from 'axios'
import {getLocalConfig} from '../functions/Common.js'

export function request(config){
	let instance = axios.create({
		baseURL: getLocalConfig("orderUrl"),
		timeout: 100000,
		headers: {
		  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		},
		transformRequest: [function (data) {
			let ret = ''
			for (let it in data) {
				ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
			}
			return ret.substr(0,ret.length-1)
		}],
		transformResponse:[
			function(data){
				return JSON.parse(data)
			}
		]
	});
	return instance(config)
}